module.exports = __webpack_public_path__ + "static/img/10.6747938.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/eng/10.png
// module id = fgy7
// module chunks = 0